exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-6832b209]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-6832b209]{display:none !important}}.o-newsletter[data-v-6832b209]{margin:var(--spacer-xl) 0;-webkit-box-sizing:border-box;box-sizing:border-box}@media (min-width: 1024px){.o-newsletter[data-v-6832b209]{margin:calc(var(--spacer-2xl) * 2) 0}}\n", ""]);

// exports
